import http from "./http-common";
import authHeader from "./auth-header";
import process from "shelljs";
import smsAuthHeader from "./sms-auth-headers";
import qs from "qs";

const API_URL = process.env.BFF_URL;
const mid = localStorage.getItem('mid')

class StockService {

  findAll(params) {
    return http.get(API_URL + "/stocks", {
      params: params, paramsSerializer: params => {
        return qs.stringify(params, {arrayFormat: 'repeat'})
      }, headers: authHeader()
    })
  }

  search(mid, searchValue) {
    return http.get(API_URL + "/stocks?name=" + searchValue, {headers: authHeader()})
  }

  findByNameAndVendorId(vendorId, searchValue, page, size) {
    return http.get(API_URL + "/stocks?vendorId=" + vendorId + "&name=" + searchValue + "&page=" + page + "&size=" + size, {headers: authHeader()})
  }

  findByMid(vendorId, params) {
    return http.get(API_URL + `/v1/stocks`, {
      params: params, paramsSerializer: params => {
        return qs.stringify(params, {arrayFormat: 'repeat'})
      }, headers: authHeader()
    })
  }

  findByBusinessId(businessId, params) {
    // Ensure businessId is in params
    const queryParams = { ...params, businessId };
    return http.get(API_URL + `/v1/stocks`, {
      params: queryParams, paramsSerializer: params => {
        return qs.stringify(params, {arrayFormat: 'repeat'})
      }, headers: authHeader()
    })
  }

  findByProductId(productId) {
    return http.get(API_URL + "/stocks?productId=" + productId, {headers: authHeader()})
  }

  findBySku(sku) {
    return http.get(API_URL + "/stocks?sku=" + sku, {headers: authHeader()})
  }

  find(barcode, sku, vendorId, page, size) {
    return http.get(API_URL + "/stocks?barcode=" + barcode + "&sku=" + sku + "&vendorId=" + vendorId + "&page=" + page + "&size=" + size, {headers: authHeader()})
  }

  findByBarcode(barcode, vendorId, page, size) {
    return http.get(API_URL + "/stocks?barcode=" + barcode + "&vendorId=" + vendorId + "&page=" + page + "&size=" + size, {headers: authHeader()})
  }

  findByStockCode(sku, vendorId, page, size) {
    return http.get(API_URL + "/stocks?sku=" + sku + "&vendorId=" + vendorId + "&page=" + page + "&size=" + size, {headers: authHeader()})
  }

  findById(mid, id, params) {
    return http.get(API_URL + `/app/merchants/${mid}/v1/stocks/${id}`, {headers: authHeader(), params: params});
  }

  create(mid, data) {
    return http.post(API_URL + `/app/merchants/${mid}/v1/stocks`, data, {headers: authHeader()});
  }

  createOld(data) {
    return http.post(API_URL + "/api/products", data, {headers: authHeader()});
  }

  update(id, data) {
    return http.put(API_URL + `/app/merchants/${mid}/v1/stocks/${id}`, data, {headers: authHeader()});
  }

  delete(id) {
    return http.delete(API_URL + `/app/merchants/${mid}/v1/stocks/${id}`, {headers: authHeader()});
  }

  addPrice(id, data) {
    return http.post(API_URL + `/stocks/${id}/prices`, data, {headers: authHeader()});
  }

  removePrice(id, data) {
    return http.delete(API_URL + `/stocks/${id}/prices`, {data, headers: authHeader()});
  }

  addInventory(id, data) {
    return http.post(API_URL + `/stocks/${id}/inventories`, data, {headers: authHeader()});
  }

  removeInventory(id, data) {
    return http.delete(API_URL + `/stocks/${id}/inventories`, {data, headers: authHeader()});
  }

  syncStocks(data) {
    return http.post(API_URL + "/api/sync/stocks", data, {headers: authHeader()});
  }

  uploadStocks(mid, file) {
    let formData = new FormData();
    formData.append("file", file)
    formData.append("merchantId", mid)
    return http.post(API_URL + `/app/merchants/${mid}/v1/stocks/upload`, formData, {headers: smsAuthHeader()});
  }
}

export default new StockService();



// WEBPACK FOOTER //
// ./src/service/stock.service.js